// @todo enable the following disabled rules see OPENTOK-31136 for more info
/* eslint-disable no-param-reassign */

const attachToOTHelpers = (mod) => {
  const attachments = {};

  Object.keys(mod).forEach((key) => {
    attachments[key] = mod[key];
  });

  mod._attachToOTHelpers = attachments;
};

export default attachToOTHelpers;
